webpackJsonp([60501389954094],{

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'Instruction' },
	      _react2.default.createElement(
	        'div',
	        { className: 'InstructionGroup' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Introduction'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Our research project aims at teaching people how gender bias is introduced and can be mitigated from AI systems. Participants will interactively implement fair AI models in terms of gender. This lab is about AI-based recruitment.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          '* You will be guided through the following steps:'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'STEP1: Learn about gender bias in the hiring process',
	          _react2.default.createElement('br', null),
	          'STEP2: Acquire data for training',
	          _react2.default.createElement('br', null),
	          'STEP3: Learn about Random Forest',
	          _react2.default.createElement('br', null),
	          'STEP4: Clean acquired data',
	          _react2.default.createElement('br', null),
	          'STEP5: Neglect gender characteristic in training',
	          _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Back'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/1-bias/' },
	          'Next step'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Go back to the homepage'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-0-introduction-js-450f80f3cb5183612f47.js